<template>
    <v-container fluid pt-5>
        <v-toolbar
                flat
                scroll-off-screen
                app
                color="grey lighten-3"
        >
            <img
                height="40"
                src="@/assets/img/logo.png"
            />
            <v-spacer></v-spacer>
            <h3 class="font-weight-light">Confirmar Cita</h3>
        </v-toolbar>

        <v-layout wrap justify-center align-center>
            <v-flex xs12 md8 lg6 text-center>
                <template v-if="status=='loading'">
                    <h1 class="headline font-weight-light">Verificando</h1>
                    <small class="caption">Un momento por favor...</small>
                </template>

                <template v-if="status=='failed'">
                    <h1 class="headline font-weight-light">Algo salió mal :(</h1>
                    <small class="caption">{{failMessage}}</small>
                </template>

                <template>
                    <v-scale-transition>
                        <v-sheet color="transparent" v-show="status === 'success'" height="200">
                            <v-avatar size="60" color="success">
                                <v-icon  color="white">fas fa-user-check</v-icon>
                            </v-avatar>
                            <h1 class="headline font-weight-light mt-2">Cita Confirmada</h1>
                            <h1 class="subtitle font-weight-light mt-2">Te esperamos!</h1>
                        </v-sheet>
                    </v-scale-transition>


                <v-slide-y-transition>
                    <v-progress-linear v-show="status=='loading'" height="2" :indeterminate="true"></v-progress-linear>
                </v-slide-y-transition>

                </template>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import { mapState, mapMutations } from 'vuex'

    export default{
        components: {},
        data(){
            return {
                status: 'loading',
                failMessage: '',
                code: this.$route.params.code
            }
        },
        mounted(){
            var vm = this
            vm.getCodeInfo()
        },
        methods:{
            ...mapMutations(['showSnackBar']),
            onError(response){
                var vm = this
                vm.failMessage = response.message || 'Ha ocurrido un error inesperado'
            },
            onSuccess(){
                var vm = this
                vm.status = 'success'
            },
            async getCodeInfo(){

                var vm = this
                const response = await ApiUtils.makePost('appointment/confirm', {
                    code: vm.code
                })

                if (!response.ok) {
                    vm.status = 'failed'
                    const json = await response.json()
                    vm.failMessage = json.message
                    return
                }

                vm.status = 'success'
                const json = await response.json()

            }
        },
        computed:{
                ...mapState(['currentUser'])
        }
    }
</script>
